import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import map from '@/components/map'

Vue.use(Router)

const router = new Router({
    // mode: 'history',   // 去除路由中的 # 号
    routes: [ 
        {
            path: '/',
            name: 'login',
            component: login,
            meta: { auth: true, keepAlive: false }
        }, {
            path: '/map',
            name: 'map',
            component: map,
            // meta: { auth: true, keepAlive: false }
        },
    ]
})


export default router;




// WEBPACK FOOTER //
// ./src/router/index.js